import dynamic from 'next/dynamic';
import { Builder } from '@builder.io/react';

// Dynamically import the HomePageQuickLinks component
const HomePageQuickLinks = dynamic(async () => {
  return (await import("./HomePageQuickLinks")).default;
});

// Register the HomePageQuickLinks component with Builder.io
Builder.registerComponent(HomePageQuickLinks, {
  name: "HomePageQuickLinks",
  inputs: [
    {
      name: "title",
      type: "string",
      defaultValue: "Quick Links",
      helperText: "Enter the title of the section",
    },
    {
      name: "links",
      type: "list",
      subFields: [
        {
          name: "displayText",
          type: "string",
          helperText: "Text displayed on the website",
        },
        {
          name: "url",
          type: "url",
          helperText: "URL the customer is redirected to when they click on the quick link on the website",
        },
        {
          name: "productImage",
          type: "ShopifyProduct",
          helperText: "They can search for a product and the primary image is used for the quick link",
        },
      ],
      helperText: "Add, edit, and reorder quick links",
    },
    {
      name: "backgroundColor",
      type: "string",
      helperText: "Configure the background colour using hex code OR upload an image",
    },
    {
      name: "backgroundImage",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "gif"],
      helperText: "Upload an image for the background",
    },
    {
      name: "deviceTypes",
      type: "list",
      subFields: [
        {
          name: "deviceType",
          type: "string",
          enum: ["desktop", "tablet", "mobile"],
          helperText: "Configure whether the quick link should only display on specific device types",
        },
      ],
    },
    {
      name: "targetApp",
      type: "boolean",
      helperText: "Target the component to show only on app",
    },
    {
      name: "whiteText",
      type: "boolean",
      helperText: "Enable for white text and icons",
    },
  ],
});